import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { FztypeListView } from './list-view/fztype.list-view';

export const fztypeFieldOk: FieldOkConfig = {
  name: 'fztype',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{type}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: FztypeListView,
        sort: {
          properties: [{ property: 'bezeichnung', title: 'Bezeichnung' }],
        },
      },
    },
  ],
};

export const fztypeMultiselectFieldOk: FieldOkConfig = {
  name: 'fztype',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{type}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: FztypeListView,
        sort: {
          properties: [{ property: 'bezeichnung', title: 'Bezeichnung' }],
        },
      },
    },
  ],
};

export const fztypeQueryFieldOk: FieldOkConfig = {
  name: 'fztype',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{type}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: FztypeListView,
        sort: {
          properties: [{ property: 'bezeichnung', title: 'Bezeichnung' }],
        },
      },
    },
  ],
};
